





























































import { Vue, Component, Watch } from "vue-property-decorator";

import { defaultHeaders, orderSelectHeader } from "./const";

import { TotalSum } from "./blocks";

import { NotFoundPage as Error } from "@/components/pages/NotFoundPage";
import PageTitle from "@/components/common/PageTitle.vue";
import Container from "@/components/common/Container.vue";
import { CartAdd } from "@/components/icons";
import { IPageMeta, IProduct } from "@/services/interfaces";
import { IOrderItem } from "@/services/interfaces/requests";
import { SortDirections } from "@/store/cart/enums";
import { Table as CartTable } from "@/components/organisms/Table";
import { IHeader } from "@/components/organisms/Table/interfaces";
import { View } from "@/components/organisms/Table/enums";

import { cartModule } from "@/plugins/store-accessors";
import { calculateTotal } from "@/store/cart/utils";

@Component({
  components: {
    CartTable,
    PageTitle,
    Error,
    Container,
    TotalSum,
    CartAdd,
  },
})
export default class ShoppingCartPage extends Vue {
  viewType = View.table;
  showBottomSum = false;
  headers = [orderSelectHeader, ...defaultHeaders];
  excludedIds: number[] = [];

  get getCartQuantity() {
    let quantity = cartModule.getCartQuantity;
    this.excludedIds.forEach((id) => {
      const productQuantity = this.getProducts.find((item) => item.id === id)
        ?.quantity as number;
      if (quantity) {
        quantity = quantity - +productQuantity;
      }
    });

    return quantity;
  }

  get getCartSum() {
    let total = cartModule.getCartSum;
    this.excludedIds.forEach((id) => {
      const productTotal = this.getProducts.find((item) => item.id === id)
        ?.custom_total_price as number;
      if (total) {
        total = total - +productTotal;
      }
    });

    return total;
  }

  get getQuantity() {
    return cartModule.getQuantity;
  }

  get getError() {
    return cartModule.getError;
  }

  get getSort() {
    return cartModule.getSort;
  }

  get getProducts() {
    return cartModule.getProducts;
  }

  get getMeta() {
    return cartModule.getMeta;
  }

  get rows(): IProduct[] {
    return this.getProducts.map((el: IProduct) => ({
      ...el,
      type: "product",
    }));
  }

  get allSelected() {
    return !this.excludedIds.length;
  }

  get ids(): number[] {
    return this.getProducts.map((item) => item.id as number);
  }

  get columnsList(): string[] {
    return this.headers.map((column: IHeader) => {
      return column.key;
    });
  }

  @Watch("getMeta")
  metaWatcher(newMeta: IPageMeta) {
    document.title = newMeta.title || "";
  }

  setType(view: View) {
    this.viewType = view;
    localStorage.setItem("viewType", view);
  }

  changeSort(sortBy: string) {
    if (this.getSort.name === sortBy) {
      if (this.getSort.direction === SortDirections.DESC) {
        cartModule.SORT_SET({ name: sortBy, direction: SortDirections.ASC });
      } else {
        cartModule.SORT_SET({ name: "", direction: null });
      }
    } else {
      cartModule.SORT_SET({ name: sortBy, direction: SortDirections.DESC });
    }
  }

  closeHandler() {
    cartModule.ORDER_CLEAR();
  }

  cartRemoveHandler(id: number) {
    cartModule.removeProduct({ id });
  }

  orderHandler() {
    const order = this.getProducts
      .filter((el) => !this.excludedIds.includes(el.id))
      .map((item) => {
        const sums = calculateTotal(item, false, true);
        const total = sums.totals.length
          ? sums.totals.reduce((a, b) => a + b)
          : 0;

        return {
          id: item.id,
          product: item,
          quantity: item.quantity,
          price: item.price,
          total_price: total,
          price_type: item.price_type,
        } as IOrderItem;
      });
    cartModule.ORDER_SET(order);
  }

  quantityHandler(payload: { id: number; val: number; priceType?: number }) {
    const type = !!payload.priceType ? payload.priceType : 0;
    cartModule.changeQuantity({
      id: payload.id,
      data: { quantity: payload.val, price_type: type },
    });
  }

  onIntersect(entries: IntersectionObserverEntry[]) {
    this.showBottomSum = !entries[0].intersectionRatio;
  }

  selectHandler({ id, value }: any) {
    if (id) {
      if (!value) {
        this.excludedIds.push(id);
      } else {
        const ids = [...this.excludedIds];
        const match = ids.findIndex((item) => item === id);
        ids.splice(match, 1);
        this.excludedIds = ids;
      }
      return;
    }
    this.excludedIds = !value ? this.ids : [];
  }

  @Watch("getSort")
  async initialRequest() {
    await cartModule.getCart();
  }

  initialObserver() {
    const intersect = this.$refs.intersection as Element;
    const options = {
      threshold: [1],
    };
    if (intersect) {
      const observer = new IntersectionObserver(this.onIntersect, options);
      observer.observe(intersect);
    }
  }

  initialType() {
    const type: string | null = localStorage.getItem("viewType");

    if (type) this.viewType = type as View;
  }

  mounted() {
    this.initialRequest();
    this.initialType();
    this.initialObserver();
  }
}
